module.exports = __webpack_public_path__ + "img/idigi-login-card.1315a115.jpg";